// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'

import Vuetify from 'vuetify'
import VeeValidate from 'vee-validate'
import 'vuetify/dist/vuetify.css'
import VueFire from 'vuefire'
import VueMoment from 'vue-moment'
import VueMask from 'v-mask'
import AsyncComputed from 'vue-async-computed'
import VueCurrencyFilter from 'vue-currency-filter'
import pt from 'vuetify/es5/locale/pt'
import moment from 'moment-timezone'
//import VueSocketIOExt from 'vue-socket.io-extended';
//import io from 'socket.io-client';
import VueCurrencyInput from 'vue-currency-input'
import VCurrencyField from 'v-currency-field'

require('moment/locale/pt')

import App from './App'
import router from './router'
import store from './store/index'


moment.tz.setDefault('America/Sao_Paulo')

Vue.use(Vuetify)
Vue.use(VeeValidate)
Vue.use(VueFire)
Vue.use(VCurrencyField, { 
	locale: 'pt-BR',
	decimalLength: 2,
	autoDecimalMode: true,
	min: null,
  max: null,
	defaultValue: 0
})
Vue.use(VueMoment, {
  moment,
})
Vue.use(VueMask)
Vue.use(AsyncComputed);

 
/*const socket = io(store.getters.server, {
  store: store,
  format: 'json',
  reconnection: true, // (Boolean) whether to reconnect automatically (false)
  reconnectionAttempts: 5, // (Number) number of reconnection attempts before giving up (Infinity),
  reconnectionDelay: 3000,
});
 
Vue.use(VueSocketIOExt, socket, store);*/
Vue.use(VueCurrencyFilter,
  {
    symbol : 'R$',
    thousandsSeparator: '.',
    fractionCount: 2,
    fractionSeparator: ',',
    symbolPosition: 'front',
    symbolSpacing: true
  })

Vue.config.productionTip = false


/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  vuetify: new Vuetify({
    icons: {
      iconfont: 'md',
    },
    lang: {
      locales: {
          pt
      },
      current: 'pt'
    }
  }),
  template: '<App/>',
  components: { App },
  created () {
    this.$store.dispatch('init');
    console.log(Vue.moment().locale())
  },
})



// WEBPACK FOOTER //
// ./src/main.js